import getPlaybackState from "selectors/chapter/getPlaybackState";
import { createSelector } from "reselect";
import getUseInactivity from "selectors/getUseInactivity";

const getChapterListVisibleState = (state) => state.modals.chapterListVisible;
const getControlsInactiveState = (state) => state.inactivity.controls;
const getCaptionSelectionVisible = (state) =>
  state.captions.showCaptionsSelectionMenu;

export default createSelector(
  getCaptionSelectionVisible,
  getChapterListVisibleState,
  getControlsInactiveState,
  getPlaybackState,
  getUseInactivity,
  (
    captionSelectionVisible,
    chapterListVisibleState,
    controlsInactiveState,
    playbackState,
    useInactivity,
  ) =>
    controlsInactiveState &&
    !chapterListVisibleState &&
    !captionSelectionVisible &&
    !playbackState.userInitiatedPause &&
    useInactivity,
);
